import CartTotal from "components/Cart/CartTotal"
import ProductTable from "components/Product/ProductTableReturn"
import { observer } from "mobx-react"
import React, { Component } from "react"
import { Button, Message,Table,Icon } from "semantic-ui-react"
import shop from "shop/shop"
import track from "shop/track"
import queryString from "qs"
import ReturnPageHeader from "pages/returnCheckout/ReturnPageHeader" 
import pdfGeneration from "components/pdfGen/pdfGeneration"

@observer
export default class ReturnPageMain extends Component {
  
  state = {
    products: getProducts(),
    frachtkosten: true,
    productsTemp: []
  }
  
  componentDidMount() {
    shop.cart.hooks.changed.add( this.updateCart )
    shop.cart.hydrate()
    track.checkout( { step: 1, products: shop.cart.products } )
    shop.cart.update()
    if(!shop.delivery){
      console.log("shop.delivery is empty")
      this.props.history.push("/return")
    }
  }
  
  handleChange = ( { product } ) => {
    shop.cart.add( product )
  }
  
  updateCart = () => {
    let products = getProducts()
    products = getProducts()
    this.setState( { products } )
    this.forceUpdate()
  }
  
  componentWillUnmount() {
    this.setState({productsTemp: shop.cart.products})
    shop.cart.hooks.changed.remove( this.updateCart )
  }
  
  render() {
    const { referer = "/", ...query } = queryString.parse( location.search, { ignoreQueryPrefix: true } )
    let { products } = this.state
    //console.log("SHOP RETURN: ", shop.return)
    
    return (
      <div>
        <pdfGeneration></pdfGeneration>
        <Table>
                <colgroup>
                    <col width="10%" />
                    <col width="15%" />
                    <col width="5%" />
                    <col width="55%" />
                </colgroup>
                <tbody>
                    <tr>
                        <td>
                            &nbsp;
                        </td>
                        <td className="pr4  pl4 v-top ReturnPageAlignment" >
                            <ReturnPageHeader className="pt7" activeStep={0} />
                        </td>
                        <td>
                            &nbsp;
                        </td>
                        <td className="pr4  pl4 v-top ReturnPageAlignment" >
                            <h1 style={{color:"#917236", fontSize:40}}  className="pt5 tl"><b>Retoure erfassen</b></h1><br/>
                            <p className="">Damit wir Ihre Retoure sicher in Empfang nehmen können, tragen Sie ihre unverkauften <br/>Lindt GmbH Artikel in der folgenden Tabelle ein.</p>
                            <br/>
                            {/*<p className="pb2">Produktsuche</p>
                            SUCHLEISTE
                            <br/><br/><br/>*/}
                            <div className="pb3">
                                {/*<OrderDetailTable products={shop.delivery[0].positions} />*/}
                                <ProductTable cart={shop.cart} onChange={this.handleChange} products={products}/>
                            </div>
                        </td>
                    </tr>
                    <tr>
                    <td>
                            &nbsp;
                        </td>
                        <td>
                            &nbsp;
                        </td>
                        <td>
                            &nbsp;
                        </td>
                        <td className="tr divAlignRight">
                        <strong>Summe: </strong>&nbsp;<CartTotal sum={shop.cart.sum} size={shop.cart.size}/>
                        </td>
                    </tr>
                    </tbody>
                </Table>
      </div>
    )
  }
}

const getProducts = () => shop.cart.map( ( product ) => product)



// WEBPACK FOOTER //
// ./src/theme/braunsheitmannShop/pages/returnCheckout/ReturnPageMain.js